import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Tone } from "@/ui/components/status-badge";

export type Forwarding = { label: string; tone: Tone; title: string };

export function useForwarding() {
  const config = useQuery({ queryKey: ["config"], queryFn: api.config, refetchInterval: 10_000 });
  const c = config.data;
  const forwarding: Forwarding = !c
    ? { label: "—", tone: "faint", title: "Forwarding status unknown" }
    : !c.forward_enabled
      ? { label: "Off", tone: "faint", title: "Forwarding is switched off in Settings" }
      : c.forward_active
        ? { label: "On", tone: "positive", title: "Forwarding to at least one downstream" }
        : { label: "Off", tone: "faint", title: "No enabled downstream" };
  return { config: c, forwarding };
}
